// store/features/actions/createCompetitorActions.js
export const CREATE_COMPETITOR_REQUEST = "CREATE_COMPETITOR_REQUEST";
export const CREATE_COMPETITOR_SUCCESS = "CREATE_COMPETITOR_SUCCESS";
export const CREATE_COMPETITOR_FAILURE = "CREATE_COMPETITOR_FAILURE";

export const createCompetitorRequest = ({
  client,
  competitor,
  competitorId,
}) => ({
  type: CREATE_COMPETITOR_REQUEST,
  payload: { client, competitor, competitorId },
});

// export const createCompetitorSuccess = () => ({
//   type: CREATE_COMPETITOR_SUCCESS,
// });

export const createCompetitorSuccess = (status) => ({
  type: "CREATE_COMPETITOR_SUCCESS",
  payload: status,
});

export const createCompetitorFailure = (error) => ({
  type: CREATE_COMPETITOR_FAILURE,
  payload: error,
});
